"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.searchPreviewProductClasses = void 0;
var _mui = require("@ori-ui/mui");
// Add more if needed

const searchPreviewProductClasses = exports.searchPreviewProductClasses = (0, _mui.generateUtilityClasses)('SearchPreviewProduct', ['root', 'inner']);
